import { render, staticRenderFns } from "./Swimming.vue?vue&type=template&id=03911aed&scoped=true&"
import script from "./Swimming.vue?vue&type=script&lang=js&"
export * from "./Swimming.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03911aed",
  null
  
)

export default component.exports